import React from 'react';

interface Props {
  width?: number;
}

const ShoppingCart: React.FC<Props> = ({ width = 24 }) => (
  <svg
    width={width ?? '20'}
    height={width ?? '20'}
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M3.33464 13.3334V3.33341H1.66797V1.66675H4.16797C4.38898 1.66675 4.60094 1.75455 4.75722 1.91083C4.9135 2.06711 5.0013 2.27907 5.0013 2.50008V12.5001H15.3663L17.033 5.83341H6.66797V4.16675H18.1013C18.228 4.16675 18.353 4.19563 18.4668 4.25119C18.5806 4.30676 18.6803 4.38754 18.7582 4.4874C18.8362 4.58727 18.8903 4.70358 18.9165 4.82751C18.9428 4.95143 18.9404 5.07971 18.9096 5.20258L16.8263 13.5359C16.7812 13.7161 16.6771 13.8761 16.5306 13.9904C16.3842 14.1047 16.2037 14.1667 16.018 14.1667H4.16797C3.94695 14.1667 3.73499 14.079 3.57871 13.9227C3.42243 13.7664 3.33464 13.5544 3.33464 13.3334ZM5.0013 19.1667C4.55927 19.1667 4.13535 18.9912 3.82279 18.6786C3.51023 18.366 3.33464 17.9421 3.33464 17.5001C3.33464 17.0581 3.51023 16.6341 3.82279 16.3216C4.13535 16.009 4.55927 15.8334 5.0013 15.8334C5.44333 15.8334 5.86725 16.009 6.17981 16.3216C6.49237 16.6341 6.66797 17.0581 6.66797 17.5001C6.66797 17.9421 6.49237 18.366 6.17981 18.6786C5.86725 18.9912 5.44333 19.1667 5.0013 19.1667ZM15.0013 19.1667C14.5593 19.1667 14.1354 18.9912 13.8228 18.6786C13.5102 18.366 13.3346 17.9421 13.3346 17.5001C13.3346 17.0581 13.5102 16.6341 13.8228 16.3216C14.1354 16.009 14.5593 15.8334 15.0013 15.8334C15.4433 15.8334 15.8673 16.009 16.1798 16.3216C16.4924 16.6341 16.668 17.0581 16.668 17.5001C16.668 17.9421 16.4924 18.366 16.1798 18.6786C15.8673 18.9912 15.4433 19.1667 15.0013 19.1667Z'
      fill='currentColor'
    />
  </svg>
);

export default ShoppingCart;
